import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { urlquestionnairesanswer } from '@/lib/custom'
import { apiGet } from '@/lib/originalFetchApi'
import { dialogRegisterQuestionnaireState } from '@/features/dialogSlice'

const PageView = () => {
  const router = useRouter()
  const dispatch = useDispatch()

  const questionnaires = async () => {
    try {
      // 回答してるかどうか
      const authQuestionnairesFetch = await apiGet(`${urlquestionnairesanswer}/1`)
      const result = (await authQuestionnairesFetch) as any

      console.log(result)

      if (result.status === 404 || result.code === 'answered') {
        // 存在しないまたは回答済み
        localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`, 'answered')
        console.log(result.message)
        dispatch(dialogRegisterQuestionnaireState(false))
        if (router.pathname.startsWith('/auth')) {
          const siteUrl =
            process.env.NEXT_PUBLIC_WITHOUT_BASE_PATH === '0'
              ? `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}`
              : `${process.env.NEXT_PUBLIC_SITEURL}`
          location.href = `${siteUrl}/`
        }

        return
      }

      if (result.code === 'unanswered') {
        console.log(result.message)
        dispatch(dialogRegisterQuestionnaireState(true))
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const Period = localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`)
    const jwt = localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`)
    const siteUrl =
      process.env.NEXT_PUBLIC_WITHOUT_BASE_PATH === '0'
        ? `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}`
        : `${process.env.NEXT_PUBLIC_SITEURL}`
    const signInPage = `${siteUrl}/auth/signin`

    if (router.pathname.startsWith('/auth')) return

    if (!jwt) {
      if (Period) return
      if (router.pathname.startsWith('/qr')) return

      location.href = signInPage
    } else {
      if (localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`)) return
      questionnaires()
    }
  }, [router.events])

  return <></>
}

export default PageView
